// extracted by mini-css-extract-plugin
export default {"root":"Checkbox__root--PTJ6k","selected":"Checkbox__selected--leQ5O","disabled":"Checkbox__disabled--3Y7FA","list":"Checkbox__list--2N4Js"};